
import { computed, defineComponent, ref, PropType } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { environment } from '@/utils/environment';

interface ExamInfo {
  userExamId: number;
  visible: boolean;
  baseInfoText: string;
  answerRule: string;
  contestId: number;
}

export default defineComponent({
  name: 'ExamInfoModal',
  props: {
    data: {
      type: Object as PropType<ExamInfo>,
      required: true,
    },
  },
  setup(props) {
    const loading = ref(false);
    const router = useRouter();
    const route = useRoute();
    const onStartExamButtonClick = () => {
      router.push({
        name: 'Examination',
        params: {
          id: props.data.userExamId,
        },
        query: route.query,
      });
    };
    const hideGetCertification = computed(() => {
      return environment === 'production'
        ? props.data.contestId === 797
        : props.data.contestId === 36;
    });
    const isNocFlag = computed(() => route.query.platform === 'noc');

    const OkText = computed(() =>
      isNocFlag.value
        ? '开始比赛'
        : hideGetCertification.value
        ? '开始答题'
        : '开始考试'
    );
    return {
      loading,
      onStartExamButtonClick,
      hideGetCertification,
      isNocFlag,
      OkText,
    };
  },
});
